import './Heading.scss';

const TAG_BY_LEVEL = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
};

/**
 * Reusable heading component using theme CSS variables.
 *
 * Usage:
 *  <Heading level={1}>Title</Heading>
 *  <Heading level={3} weight={900} color="primary">Section</Heading>
 */
export default function Heading({
  level = 1,
  children,
  className = '',
  align, // 'left' | 'center' | 'right'
  color = 'text', // 'text' | 'primary' | 'accent' | 'bg'
  weight, // number like 300/400/500/800/900
  italic = false,
  style,
  ...props
}) {
  const L = Number(level);
  const Tag = TAG_BY_LEVEL[L] || 'h1';

  const classes = [
    'typo-heading',
    `typo-heading--h${Tag === 'h1' ? 1 : L}`,
    align ? `typo-heading--align-${align}` : '',
    color ? `typo-heading--color-${color}` : '',
    italic ? 'typo-heading--italic' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={classes} style={{ ...(weight ? { fontWeight: weight } : null), ...style }} {...props}>
      {children}
    </Tag>
  );
}

